const RcWidgetLiveResultsAlpha1 = () => import(/* webpackChunkName: "RcWidgetLiveResultsAlpha1" */ "./RcWidgetLiveResultsAlpha1.vue");
const RcWidgetLiveResultsAlpha2 = () => import(/* webpackChunkName: "RcWidgetLiveResultsAlpha2" */ "./RcWidgetLiveResultsAlpha2.vue");
const RcWidgetLiveResultsAlpha3 = () => import(/* webpackChunkName: "RcWidgetLiveResultsAlpha3" */ "./RcWidgetLiveResultsAlpha3.vue");
const RcWidgetLiveResultsBeta1 = () => import(/* webpackChunkName: "RcWidgetLiveResultsBeta1" */ "./RcWidgetLiveResultsBeta1.vue");
const RcWidgetLiveResultsBody = () => import(/* webpackChunkName: "RcWidgetLiveResultsBody" */ "./RcWidgetLiveResultsBody.vue");
const RcWidgetLiveResultsGovernor = () => import(/* webpackChunkName: "RcWidgetLiveResultsGovernor" */ "./RcWidgetLiveResultsGovernor.vue");
const RcWidgetLiveResultsHouse = () => import(/* webpackChunkName: "RcWidgetLiveResultsHouse" */ "./RcWidgetLiveResultsHouse.vue");
const RcWidgetLiveResultsHouseTop50 = () => import(/* webpackChunkName: "RcWidgetLiveResultsHouseTop50" */ "./RcWidgetLiveResultsHouseTop50.vue");
const RcWidgetLiveResultsHouseNortheast = () => import(/* webpackChunkName: "RcWidgetLiveResultsHouseNortheast" */ "./RcWidgetLiveResultsHouseNortheast.vue");
const RcWidgetLiveResultsHouseMidwest = () => import(/* webpackChunkName: "RcWidgetLiveResultsHouseMidwest" */ "./RcWidgetLiveResultsHouseMidwest.vue");
const RcWidgetLiveResultsHouseSouth = () => import(/* webpackChunkName: "RcWidgetLiveResultsHouseSouth" */ "./RcWidgetLiveResultsHouseSouth.vue");
const RcWidgetLiveResultsHouseWest = () => import(/* webpackChunkName: "RcWidgetLiveResultsHouseWest" */ "./RcWidgetLiveResultsHouseWest.vue");
const RcWidgetLiveResultsPresident = () => import(/* webpackChunkName: "RcWidgetLiveResultsHouseWest" */ "./RcWidgetLiveResultsPresident.vue");
const RcWidgetLiveResultsSenate = () => import(/* webpackChunkName: "RcWidgetLiveResultsSenate" */ "./RcWidgetLiveResultsSenate.vue");

Vue.component('rc-widget-live-results-alpha-1', RcWidgetLiveResultsAlpha1);
Vue.component('rc-widget-live-results-alpha-2', RcWidgetLiveResultsAlpha2);
Vue.component('rc-widget-live-results-alpha-3', RcWidgetLiveResultsAlpha3);
Vue.component('rc-widget-live-results-beta-1', RcWidgetLiveResultsBeta1);
Vue.component('rc-widget-live-results-body', RcWidgetLiveResultsBody);
Vue.component('rc-widget-live-results-governor', RcWidgetLiveResultsGovernor);
Vue.component('rc-widget-live-results-house', RcWidgetLiveResultsHouse);
Vue.component('rc-widget-live-results-house-top-50', RcWidgetLiveResultsHouseTop50);
Vue.component('rc-widget-live-results-house-northeast', RcWidgetLiveResultsHouseNortheast);
Vue.component('rc-widget-live-results-house-midwest', RcWidgetLiveResultsHouseMidwest);
Vue.component('rc-widget-live-results-house-south', RcWidgetLiveResultsHouseSouth);
Vue.component('rc-widget-live-results-house-west', RcWidgetLiveResultsHouseWest);
Vue.component('rc-widget-live-results-president', RcWidgetLiveResultsPresident);
Vue.component('rc-widget-live-results-senate', RcWidgetLiveResultsSenate);

function init_app(selector, name)
{
    new Vue({
        el: selector,
        name: name,
    });
}

function lazy_init_app(selector, name)
{
    var lazy_init_callback = function(){
        if( window.$(selector) && window.$(selector).inViewport(50) && window.$(selector).is(':visible') ){
            init_app(selector, name);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

/**
 * Init apps to lazy load if element on page and user on it the element
 */
function init_apps(){

    lazy_init_app('#live_results_alpha_1', 'live_results_alpha_1_app');

    lazy_init_app('#live_results_alpha_1_mobile', 'live_results_alpha_1_mobile_app');

    if(document.querySelector('rc-widget-live-results-alpha-2')) {
        document.querySelectorAll('rc-widget-live-results-alpha-2').forEach(function(elem, index) {
            lazy_init_app(elem, `rc-widget-live-results-alpha-2-index-${index}-app`);
        });
    }

    lazy_init_app('#live_results_alpha_3', 'live_results_alpha_3_app');

    lazy_init_app('#live_results_alpha_3_mobile', 'live_results_alpha_3_mobile_app');

    lazy_init_app('#live_results_beta_1', 'live_results_beta_1_app');

    lazy_init_app('#live_results_beta_1_mobile', 'live_results_beta_1_mobile_app');

    lazy_init_app('#live_results_governor', 'live_results_governor_app');

    lazy_init_app('#live_results_house', 'live_results_house_app');

    lazy_init_app('#live_results_president', 'live_results_president_app');

    lazy_init_app('#live_results_senate', 'live_results_senate_app');

    lazy_init_app('#live_results_house_top_50', 'live_results_house_top_50_app');

    lazy_init_app('#live_results_house_northeast', 'live_results_house_northeast_app');

    lazy_init_app('#live_results_house_midwest', 'live_results_house_midwest_app');

    lazy_init_app('#live_results_house_south', 'live_results_house_south_app');

    lazy_init_app('#live_results_house_west', 'live_results_house_west_app');

    lazy_init_app('#live_results_state', 'live_results_state_app');

    var all_closeups = document.querySelectorAll('rc-widget-state-closeups');
    if(all_closeups.length > 0) {
        for(var i = 0; i < all_closeups.length; i++) {
            lazy_init_app(all_closeups[i], `rc-widget-state-closeups-index-${i}-app`);
        }
    }

}

export default init_apps;